import type { CustomAnalyticsChart } from "@redotech/redo-analytics-common/reports/custom-analytics-chart";
import { memo } from "react";
import { BarChartBody } from "./chart-body-bar";
import { LineChartBody } from "./chart-body-line";
import { PieChartBody } from "./chart-body-pie";

export const ChartBody = memo(function ChartBody({
  chart,
  formatValue,
}: {
  chart: CustomAnalyticsChart;
  formatValue: (value: number) => string;
}) {
  switch (chart.chartType) {
    case "pie":
      return <PieChartBody chart={chart} formatValue={formatValue} />;
    case "bar":
      return <BarChartBody chart={chart} formatValue={formatValue} />;
    case "line":
      return <LineChartBody chart={chart} formatValue={formatValue} />;
  }
});
